const API = process.env.REACT_APP_API
export default  API 